import React from "react";
import "../Footer.css";

interface CompanyInfoProps {
  logoForluz: string;
}

const CompanyInfo: React.FC<CompanyInfoProps> = ({ logoForluz }) => {
  return (
    <div className="footer-company-info">
      <img
        src={logoForluz}
        alt="Logo Forluz"
        className="footer-logo"
      />
      <h5 className="footer-phone">
        0800 - 090 9090
      </h5>
    </div>
  );
};

export default CompanyInfo;
